import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { OrderState, Response } from '@app/_models';

import { Observable } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { HttpErrorHandlerService, HandleError } from './http-error-handler.service';



@Injectable({
  providedIn: 'root'
})
export class OrderService {

  orderStatusEndpoint = "Ordini/CheckOrderStatus";
  orderUnlockEndpoint = "Ordini/UnlockOrder";
  orderStateListEndpoint = "Ordini/StatusList";
  private handleError: HandleError;

  constructor(
    private http: HttpClient,
    httpErrorHandler: HttpErrorHandlerService) {
    this.handleError = httpErrorHandler.createHandleError('PromoService');
  }

  //TODO: post current date incapsulated in json (?)
  downloadOrderStateList(): Observable<OrderState[]> {

    const requestJson = {
      data: "",
      limit: 200,
      order: "ascending"
    }; // add visualization options

    return this.http.post<Response<OrderState[]>>(environment.apiURL+environment.apiVersion+this.orderStateListEndpoint, requestJson)
    .pipe(
      map(response => response.content),
      catchError(this.handleError(this.orderStateListEndpoint))
    )
  }

  checkOrderStatus(orderNumber: String): Observable<String> {
    return this.http.post<String>(environment.apiURL+environment.apiVersion+this.orderStatusEndpoint, orderNumber)
    .pipe(
      catchError(this.handleError(this.orderStatusEndpoint))
    );
  }

  unlockOrder(orderNumber: String): Observable<String> {
    return this.http.post<String>(environment.apiURL+environment.apiVersion+this.orderUnlockEndpoint, orderNumber)
    .pipe(
      catchError(this.handleError(this.orderUnlockEndpoint))
    );
  }
}
